module.exports = __webpack_public_path__ + "img/17.001d732f.jpg";